import React from "react";

import { useLogout } from "../../hooks";
import { fastDrawLogo } from "../../images";
import { SUPPORT_LINK } from "../../redux/constants";
import { useAppSelector } from "../../redux/hooks";
import { Button } from "../Button/button";
import { Footer } from "../Footer/footer";

export const NoProductScreen = () => {
  const { token } = useAppSelector((state) => state.auth);

  const { logout } = useLogout(token);

  return (
    <div
      className="full-height full-width position-fixed"
      style={{
        background: "#121212",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          padding: 30,
        }}
        className="display-flex justify-content-space-between full-width"
      >
        <img src="https://id.fastmodelsports.com/assets/hudl/FastDrawHudl.png" width={300} alt="FastDraw Hudl Logo" />
        {/* <img
            src="https://id.fastmodelsports.com/assets/hudl/FastScout.png"
            width={200}
            alt="Hudl Logo"
          /> */}
      </div>
      <div
        className="display-flex flex-direction-column align-items-center "
        style={{
          background: "#191f25",
          width: 400,
          padding: 30,
          textAlign: "left",
          borderRadius: 10,
          color: "#c3cedb",
          fontFamily: "helvetica",
        }}
      >
        <div className="helvetica" style={{ fontSize: 30, color: "#c3cedb", textAlign: "center", marginBottom: "1em" }}>
          FastDraw Subscription Required
        </div>
        Want to get started with FastDraw, or already have a subscription? Get in touch with Hudl support.
        <div className="display-flex justify-content-center align-items-center mg-top-xl">
          <a
            style={{
              border: "1px solid black",
              padding: "15px 100px",
              fontWeight: "normal",
              backgroundColor: "#027dbb",
              color: "#FFF",
              textDecoration: "none",
            }}
            href={SUPPORT_LINK}
          >
            Contact Support
          </a>
        </div>
        <div
          onClick={() => {
            logout();
          }}
          style={{
            marginTop: "2em",
            cursor: "pointer",
            color: "#c3cedb",
            textAlign: "center",
          }}
        >
          Back to Hudl
        </div>
        <Footer />
      </div>
    </div>
  );
};
